export interface PaginatedList<T> extends PaginationInfo {
  items: T[];
}

export interface PaginationInfo {
  total: number;
  currentPage: number;
  pageSize: number;
  isLastPage: boolean;
}

export const DEFAULT_PAGINATION_INFO: PaginationInfo = {
  currentPage: 0,
  pageSize: 0,
  total: 0,
  isLastPage: false,
};
